import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			privacyPolicyContentSectionCls: string;
		}
	},

	slug: string
}

class Legal extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Privacy Policy Legal Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.privacyPolicyContentSectionCls || '', 'privacy_policy_legal', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Legal;